import { Container } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import './index.css';
import { TanstackQueryClientProvider } from './provider/react-query';
import { router } from './routes';
import { useSettingsStore } from './store';

export const App = () => {
  const { darkTheme } = useSettingsStore();

  return (
    <TanstackQueryClientProvider>
      <Container
        component='main'
        sx={{
          minWidth: '100vw',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          '::-webkit-scrollbar': {
            width: '100px'
          }
        }}>
        <ToastContainer theme={darkTheme ? 'dark' : 'light'} key={darkTheme.toString()} />
        <RouterProvider router={router} />
      </Container>
    </TanstackQueryClientProvider>
  );
};
